module.exports = __webpack_public_path__ + "static/media/Chantal.6679eeb5.jpg";